/**
 * tdesign v1.5.1
 * (c) 2023 tdesign
 * @license MIT
 */

var PRO_THEME = {
  LINE: "line",
  PLUMP: "plump",
  CIRCLE: "circle"
};
var CIRCLE_SIZE = {
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large"
};
var CIRCLE_SIZE_PX = {
  SMALL: 72,
  MEDIUM: 112,
  LARGE: 160
};
var CIRCLE_FONT_SIZE_RATIO = {
  SMALL: 14 / CIRCLE_SIZE_PX.SMALL,
  MEDIUM: 20 / CIRCLE_SIZE_PX.MEDIUM,
  LARGE: 36 / CIRCLE_SIZE_PX.LARGE
};
var STATUS_TEXT = ["success", "error", "warning", "active", "normal"];
var STATUS_ICON = ["success", "error", "warning"];
var constants = {
  PRO_THEME: PRO_THEME,
  CIRCLE_SIZE: CIRCLE_SIZE,
  CIRCLE_SIZE_PX: CIRCLE_SIZE_PX,
  STATUS_TEXT: STATUS_TEXT,
  STATUS_ICON: STATUS_ICON
};

export { CIRCLE_FONT_SIZE_RATIO, CIRCLE_SIZE, CIRCLE_SIZE_PX, PRO_THEME, STATUS_ICON, STATUS_TEXT, constants as default };
//# sourceMappingURL=constants.mjs.map
